export const setFlyoutDimensions = (instance, menuIndex) => {
    if (menuIndex === undefined) {
        return;
    }
    const menuList = instance.querySelector('.Dropdown-menuList');
    const flyout = instance.querySelector(`.MenuListItem-root:nth-of-type(${menuIndex + 1}) .Dropdown-flyout`);
    if (!menuList || !flyout) {
        return;
    }
    const borderWidth = 1;
    const menuListWidth = Math.ceil(menuList.offsetWidth);
    const flyoutWidth = Math.ceil(flyout.offsetWidth);
    const menuWrapperHeight = Math.ceil(flyout.offsetHeight >= menuList.offsetHeight ? flyout.offsetHeight : menuList.offsetHeight);
    const menuWrapperWidth = Math.ceil(menuListWidth + flyoutWidth + borderWidth);
    instance.style.setProperty('--dropdown-menu-wrapper-height', `${menuWrapperHeight}px`);
    instance.style.setProperty('--dropdown-menu-wrapper-width', `${menuWrapperWidth}px`);
    flyout.style.setProperty('--flyout-spacing-left', `${menuListWidth}px`);
};
